export default __webpack_public_path__ + "static/media/img_share_challenge.f917d1c6.png";